import actions from './actions';
import mutations from './mutations';
import getters from './getters';
var state = {
  attributes: [],
  useCaseRequest: null,
  companyAbrevs: {},
  labelCatalog: null,
  statusLogTypes: null,
  attributeSourcesCatalog: null,
  solicitudeTypes: {},
  businessUserServiceAccounts: [],
  notificaciones_usuarios: [],
  flagCustomExpirationSbx: false,
  groupsByOrg: {
    company_code: '',
    company_name: '',
    groups: []
  },
  groupsByOrgCache: {},
  organizations: [],
  orgGroupCounts: {}
};
export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
};